import { Link } from 'react-router-dom';
import { Expense } from '../../shared/models/expense';
import ExpenseRow from './expense-row';

export interface ExpensesProps {
	expenses: Expense[];
	circleId: string;
	loggedInUserId: string;
}

export default function ListExpenses({ expenses, circleId, loggedInUserId }: ExpensesProps) {
	return (
		<div>
			{expenses.map(expense => (
				<Link
					key={expense.id}
					to={expense.isSettlement ? '' : `/secure/expense/${expense.id}`}
					state={{ circleId }}>
					<ExpenseRow key={expense.id} expense={expense} loggedInUserId={loggedInUserId} />
				</Link>
			))}
		</div>
	);
}
